import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import { Icon } from "./icon";
import styles from "./styles.scss";

function DropPreview(_: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.dropPreview}>
      <Icon className={styles.icon} />
      <h2 className={styles.message}>{t("documentUpload.message")}</h2>
    </div>
  );
}

export { DropPreview };
